import styled from 'styled-components';

import CloseIcon from '../buttons/svgs/CloseIcon.svg';
import BackIcon from '../buttons/svgs/back.svg';

export const StyledButton = styled.button`
  background: transparent;
  border: ${({ border }) => border || 'none'};
  position: absolute;
  transform-origin: center center;
  padding: ${({ padding }) => padding || 0};
  top: ${({ top }) => top || 0};
  left: ${({ left }) => left || 0};
  cursor: pointer;
  margin: 0;

  &:disabled {
    cursor: default;
  }
`;

export const SVGImage = styled.img(props => ({
  position: 'relative',
  ...props,
}));

export const ActionButton = styled.button`
  border: 0;
  padding: 0;
  cursor: pointer;

  background-color: #499689;
  width: 250px;
  height: 80px;
  border-radius: 40px;
  position: relative;

  font-family: Quicksand;
  font-weight: bold;
  color: #ffffff;
  font-size: 34px;
  text-align: center;

  &:before {
    content: '';
    display: block;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    border: 2px solid rgba(29, 23, 18, 0.8);
    border-radius: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  &:disabled {
    cursor: default;
    background-color: #4B3627;
    
    &:before {
      display none;
    }
  }
`;

export const CloseButton = styled.button.attrs((props) => ({
  'aria-label': props['aria-label'] || 'Close Modal',
}))`
  width: 48;
  height: 48;
  background-image: url(${CloseIcon});
  border: none;
  margin: 0;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
`;

export const BackIconButton = styled.button`
  width: 80px;
  height: 80px;
  background: url(${BackIcon}) center;
  padding: 0;
  border: none;
  box-shadow: none;
  cursor: pointer;
`;
